import { batch, observable } from '@legendapp/state'
// import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { isEmpty } from 'radash'

type Route$ = {
  status: 'navigating' | 'idle'
  currentPath: string | null
  previousPath: string | null
  registeredPages: string[]
  registerPage: (path: string) => void
  tracePath: (path: string) => void
  fallbackPath: (type: 'auth' | 'public') => string
  setIdle: () => void
  // goBack: (router: AppRouterInstance) => void
  signOut: (() => Promise<void>) | null
}

export const route$ = observable<Route$>({
  status: 'idle',
  currentPath: null,
  previousPath: null,
  registeredPages: [],
  signOut: null,
  registerPage: (path: string) => {
    const existingRegisteredPath = route$.registeredPages.get()

    if (!isEmpty(path) && !existingRegisteredPath.includes(path)) {
      batch(() => {
        route$.registeredPages.push(path)
        route$.status.set('navigating')
      })
    }
  },
  tracePath: (path: string) => {
    const foundRegisterPath = route$.registeredPages.find(registeredPath =>
      path.startsWith(registeredPath.get()),
    )

    if (foundRegisterPath?.get()) {
      route$.status.set('navigating')
    }
    batch(() => {
      route$.previousPath.set(route$.currentPath.get())
      route$.currentPath.set(path)
    })
  },
  fallbackPath: (type): string => {
    const previousPath = route$.previousPath.get()
    if (type === 'auth') {
      if (!isEmpty(previousPath) && previousPath?.startsWith('/console')) {
        return previousPath!
      }

      return '/console'
    }
    else {
      if (!isEmpty(previousPath) && !previousPath?.includes('console')) {
        return previousPath!
      }

      return '/'
    }
  },
  setIdle: () => {
    route$.status.set('idle')
  },
  // goBack: (router) => {
  //   const previousPath = route$.previousPath.get()
  //   const currentPath = route$.currentPath.get()

  //   if (previousPath === currentPath || previousPath === location.pathname) {
  //     return router.replace('/')
  //   }

  //   return router.replace(previousPath || '/')
  // },
})
